import { render, staticRenderFns } from "./business-auth.vue?vue&type=template&id=15372ea8&scoped=true&"
import script from "./business-auth.vue?vue&type=script&lang=js&"
export * from "./business-auth.vue?vue&type=script&lang=js&"
import style0 from "./business-auth.vue?vue&type=style&index=0&id=15372ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15372ea8",
  null
  
)

export default component.exports